export default class IsVisible {
  isVisible = true;
}
